// extracted by mini-css-extract-plugin
module.exports = {"xboost_h5":"xboost_xboost_h5__v7oKT"};